import Vue from 'vue'
import * as Sentry from "@sentry/browser";
import i18nEN from '../lang/en.json';
import i18nJA from '../lang/ja.json';
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
	locale: 'ja',
	fallbackLocale: 'en',
	messages: {
		en: i18nEN,
		ja: i18nJA,
	},
	/*
	numberFormats: {
	  en: numberFormats,
	  ja: numberFormats
	},
	*/
  missing: (locale, key, vm, values) => {
    const message = `i18n missing ${locale} ${key}`
    Sentry.captureMessage(message,(scope) => {
      scope.setUser({uid: vm?.$store.getters.uid});
      return scope
    })
  },
})

export default i18n
